// extracted by mini-css-extract-plugin
export default {"lineColor":"var(--dark-gray)","OrgChart":"OrgChart_OrgChart__wD8os","card":"OrgChart_card__1wrHQ","description":"OrgChart_description__lU-iU","button":"OrgChart_button__HAk4h"};